import { ArcGauge } from '@progress/kendo-react-gauges'
import * as Grid from '@progress/kendo-react-grid'
import React from 'react'
import * as RasaColors from '../../colors'

interface ArcOptions {
  colors: any,
  height: string,
  value: number,
  width: string,
}

interface Colors {
  [key: string]: object[],
  bad: object[],
  good: object[],
}

type GaugeContainer<T> = (x: T) => any

export class GaugeCell extends Grid.GridCell {
  private category: string

  private colors: Colors = {
    bad: [
      {
        color: RasaColors.red300,
        from: 0,
        to: 89,
      },
      {
        color: RasaColors.red500,
        from: 90,
        to: 100,
      },
    ],
    good: [
      {
        color: RasaColors.cyan300,
        from: 0,
        to: 89,
      },
      {
        color: RasaColors.cyan500,
        from: 90,
        to: 100,
      },
    ],
  }

  private arcOptions: ArcOptions = {
    colors: this.colors[this.category],
    height: '100%',
    value: this.props.dataItem[this.props.field] * 100,
    width: '100%',
  }

  private gaugeStyles = {
    display: 'block',
  }

  constructor(
    props: Grid.GridCellProps,
    category: string,
  ) {
    super(props)
    this.category = category
  }

  public render() {
    this.arcOptions.colors = this.colors[this.category]

    return <td>
      <div>
          <this.GaugeContainer {...this.arcOptions} />
      </div>
    </td>
  }

  private arcCenterRenderer = (currentValue: number, color: string) => {
    return (<h6 style={{ color }}>{currentValue}%</h6>);
  }

  private GaugeContainer: GaugeContainer<any> = () => (
            <div>
                <ArcGauge {...this.arcOptions} arcCenterRender={this.arcCenterRenderer} style={this.gaugeStyles} />
            </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/grid-cell/gauge_cell.tsx